<script>
export default {
  name: "Base",
  props: {
    data: {
      type: Object,
    }
  },
  data() {
    return {
      visible: false,
    }
  },
  beforeMount() {
    // Insert the component in body tag
    document.body.appendChild(this.$el)
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      this.visible = true

      this.$emit('show');
    },
    destroy(data) {
      this.visible = false
      this.$emit('destroy', data)

      // Timeout for the animation complete before destroying
      setTimeout(() => {
        const el = this.$el
        this.$destroy()

        if (typeof el.remove !== 'undefined') {
          el.remove()
        } else {
          el.parentNode.removeChild(el)
        }
      }, 150)
    }
  }
}
</script>
